// Centralized API Configuration
// Priority: window.location.origin (production browser) → REACT_APP_API_URL env var → localhost:3001 (dev)
export const getServerURL = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (typeof window !== 'undefined' && window.location) {
    // If frontend is accessed via dev port 3000, backend is on port 3001
    if (window.location.port === '3000') {
      return `${window.location.protocol}//${window.location.hostname}:3001`;
    }
    // If running in a browser and not on localhost, use current origin as fallback
    if (window.location.hostname !== 'localhost') {
      return window.location.origin;
    }
  }
  return 'http://localhost:3001';
};
